import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll, ScrollToTop } from "@/components/Motion";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Training from "@/pages/Training";
import CapabilityFramework from "@/pages/CapabilityFramework";
import Projects from "@/pages/Projects";
import Resources from "@/pages/Resources";
import FundingSupport from "@/pages/FundingSupport";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/training" element={<Training />} />
            <Route path="/capability-framework" element={<CapabilityFramework />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/funding-support" element={<FundingSupport />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </SmoothScroll>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
